import axios from "axios";

const baseUrl = `${process.env.REACT_APP_BACKEND_HOST}`;

const readAllUserListForSMS = async (param) => {
  const { data } = await axios.get(`${baseUrl}/user/readAll/smsTarget`, {
    params: param,
  });
  return data;
};

const createGuestUser = async (param) => {
  const { data } = await axios.post(`${baseUrl}/user/admin/user_join`, param);
  return data;
};

const getUserInfo = async (user_id) => {
  const { data } = await axios.get(`${baseUrl}/admin/get/info/${user_id}`);
  return data;
};

const inquiryKakaoSend = async (param) => {
  const { data } = await axios.post(`${baseUrl}/user/kakaoSend`, param);
  return data;
};

const reEnterPassword = async (param) => {
  const { data } = await axios.post(`${baseUrl}/user/password/reEnter`, param);
  return data;
};

const userAllowAdmin = async (param) => {
  const { data } = await axios.post(`${baseUrl}/user/admin/allow`, param);
  return data;
};

const userDisallowAdmin = async (param) => {
  const { data } = await axios.post(`${baseUrl}/user/admin/disAllow`, param);
  return data;
};

const userLeaveForAdmin = async (param) => {
  const { data } = await axios.delete(`${baseUrl}/user/admin/leave`, {
    params: param,
  });
  return data;
};

const userAuthApi = {
  readAllUserListForSMS,
  createGuestUser,
  getUserInfo,
  inquiryKakaoSend,
  reEnterPassword,
  userAllowAdmin,
  userDisallowAdmin,
  userLeaveForAdmin,
};

export default userAuthApi;
